import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import * as SecurityActions from '@redux/onboarding/security-step/security-step-action'
import * as OnboardingSelector from 'selectors/onboarding/onboarding-selector'
import { BoxReCaptcha } from './security-step-style'

import TemplateStep from '@components/layout/template-step'
import InputPassword from '@components/input/input-password/input-password'
import PasswordStrength from '@components/password-strength/password-strength'
import ReCaptchaV2 from '@components/re-captcha-v2/re-captcha-v2'

import { useWindowSize } from '@utilities/event-hooks-utility'

const SecurityStep = ({ match }) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 768

  const dispatch = useDispatch()
  const security = useSelector(OnboardingSelector.security)

  const [reCaptchaToken, setReCaptchaToken] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [hasCustomError, setHasCustomError] = useState(false)

  const handleConfirmBlur = async ({ value, name }) => {
    setHasCustomError(false)
    if (security.password !== value) {
      setHasCustomError(true)
    }
  }
  const handleChange = ({ value, name }) => {
    dispatch(SecurityActions.setSecurityField(name, value))
  }

  useEffect(() => {
    dispatch(SecurityActions.setSecurityField('planId', match?.params?.planId))
  }, [match, dispatch])

  useEffect(() => {
    dispatch(SecurityActions.setSecurityField('captcha', reCaptchaToken))
  }, [reCaptchaToken])

  return (
    <TemplateStep externalValidations={[!reCaptchaToken]}>
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="col-12">
            <InputPassword
              label="Senha"
              id="password"
              name="password"
              fixedLabel
              required
              value={security.password}
              onChange={handleChange}
              invalidPasswordMessage={'senha inválida'}
              isValidPassword={isValid}
              hasCustomError={hasCustomError}
            />
          </div>
          <div className="col-12">
            <InputPassword
              label="Confirmar Senha"
              id="confirmPassword"
              name="confirmPassword"
              fixedLabel
              required
              value={security.confirmPassword}
              onBlur={handleConfirmBlur}
              onChange={handleChange}
              disabled={!isValid}
              isValidPassword={isValid}
              hasCustomError={hasCustomError}
              customErrorMessage={'as senhas precisam ser iguais'}
            />
          </div>
          <BoxReCaptcha>
            <ReCaptchaV2 size={isMobile ? 'compact' : 'normal'} onChange={setReCaptchaToken} />
          </BoxReCaptcha>
        </div>
        <div className="col-12 col-sm-6">
          <PasswordStrength value={security.password} statusRules={setIsValid} />
        </div>
      </div>
    </TemplateStep>
  )
}

SecurityStep.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      planId: PropTypes.string,
    }),
  }),
}
SecurityStep.displayName = 'SecurityStep_Page'

export default SecurityStep
